import React, { useEffect, useState } from "react";
import { Form, Button, Modal } from "react-bootstrap";

export const ReviseGuestForm = ({ idx, updateGuest, guest, formIsValid }) => {
	const [name, _setName] = useState(""),
		[peopleId, _setPeopleId] = useState(0),
		[showWarningModal, setShowWarningModal] = useState(false);

	useEffect(() => {
		let subscribed = true;
		if (subscribed) {
			if (guest) {
				_setName(guest.name);
				_setPeopleId(guest.people_id);
			} else {
				//
			}
		}
		return () => {
			subscribed = false;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [guest]);

	const handleChange = (val) => {
		_setName(val);
		if (guest) {
			updateGuest(idx, { people_id: peopleId, name: val }, false);
		}
	};

	const removeGuest = () => {
		if (guest) {
			updateGuest(idx, { people_id: peopleId, name: name }, true);
		}
		_setName("");
		_setPeopleId(0);
	};

	return (
		<div className="row">
			<div className="col col-12 position-relative">
				<div className="d-flex flex-row gap-2 w-100 justify-content-between">
					<div className={"flex-fill"}>
						<Form.Group controlId="guest_name">
							<Form.Control
								value={name}
								required
								className={"nf-sans-cond fw-bold"}
								style={{
									color: "#000",
									opacity: 1,
									border: "4px solid #000",
								}}
								onChange={(e) => {
									handleChange(e.target.value);
								}}
								onBlur={(e) => {
									handleChange(e.target.value);
								}}
								placeholder="Guest Name"
							/>
						</Form.Group>
					</div>

					{name || name === "" ? (
						<div
							className={"flex-shrink-1"}
							style={
								{
									// position: "absolute",
									// top: 5,
									// right: "1.1rem",
								}
							}
						>
							<Button
								className="rsvp-edit-button "
								style={{
									fontSize: ".8rem",
									border: 0,
								}}
								onClick={() => {
									setShowWarningModal(true);
								}}
							>
								Remove Guest
							</Button>
						</div>
					) : null}
				</div>

				{name === "" ? (
					<div
						className="validation__message text-white text-uppercase mt-2"
						style={{ fontSize: "1rem" }}
					>
						Please enter the guest's name
					</div>
				) : (
					""
				)}
			</div>

			<Modal
				show={showWarningModal}
				onHide={() => {
					setShowWarningModal(false);
				}}
				size="lg"
				dialogClassName="event__modal-new eventmodal__container nf-sans-cond text-white"
				centered={true}
			>
				<Modal.Body>
					<div
						className="my-3 text-center fw-bold text-white"
						style={{ fontSize: "1.3rem" }}
					>
						Are you sure you want to remove this guest?
					</div>
					<div className="justify-content-center mb-2 d-flex">
						<Button
							className="px-4 rsvp-edit-button white-button"
							onClick={(e) => {
								setShowWarningModal(false);
								removeGuest();
							}}
						>
							Yes
						</Button>
						<Button
							className="ms-2  px-4 rsvp-edit-button white-button "
							onClick={(e) => {
								setShowWarningModal(false);
							}}
						>
							No
						</Button>
					</div>
				</Modal.Body>
			</Modal>
		</div>
	);
};
